import { render } from "./AppLoading.vue?vue&type=template&id=322ec5f2&scoped=true"
const script = {}

import "./AppLoading.vue?vue&type=style&index=0&id=322ec5f2&lang=scss&scoped=true"

import exportComponent from "../../../.yarn/__virtual__/vue-loader-virtual-cc52297f69/2/root/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322ec5f2"]])

export default __exports__